module.exports = __webpack_public_path__ + "img/2f2c94b56965c62fd288b49a0c6c12e1.png";